import Repository from '@/api/Repository';

export default {
  returnMockWeather() {
    const weather = [
      {
        city: 'Bydgoszcz',
        weather: {
          temp: this.getRandom(),
          description: 'few clouds',
          icon: '02n',
        },
        enters: Math.floor(Math.random() * 100 + 3),
      }, {
        city: 'Toruń',
        weather: {
          temp: this.getRandom(),
          description: 'clear sky',
          icon: '01n',
        },
        enters: Math.floor(Math.random() * 100 + 3),
      }, {
        city: 'Włocławek',
        weather: {
          temp: this.getRandom(),
          description: 'broken clouds',
          icon: '04n',
        },
        enters: Math.floor(Math.random() * 100 + 3),
      }, {
        city: 'Gdańsk',
        weather: {
          temp: this.getRandom(),
          description: 'broken clouds',
          icon: '04n',
        },
        enters: Math.floor(Math.random() * 100 + 3),
      },
    ];

    return weather[Math.floor(Math.random() * 3)];
  },
  getRandom() {
    return Math.floor(Math.random() * (28 - 22 + 1)) + 22;
  },
  getWeather(groupID, dayInterval, token) {
    return Repository.get(`/administer/locales?groupId=${groupID}&fetchWeather=true&weatherDay=${dayInterval}`, {
      headers: {
        Authorization: token,
      },
    })
      .then(response => response.data)
      .catch(
        error => console.log(error),
      );
  },
};
